import { useRouter } from 'vue-router';

import { notificationType } from '@/types/notifications';

export const useNotificationRedirect = () => {
  const router = useRouter();

  const handleRedirect = (notification: notificationType) => {
    const r = notification.redirect;
    if (!r) {
      return;
    }

    if (r.import_url) {
      router.push({ name: 'c-contacts' });
      return;
    }

    if (r.conversationId) {
      router.push({
        name: 'c-all-conversations',
        params: { conversationId: r.conversationId },
        ...(r.messageId && { query: { messageId: r.messageId } }),
      });
    }
  };

  return { handleRedirect };
};
